import { Card, CardBody, Divider, HStack, SimpleGrid, Stack, Text, VStack } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { adminGetDashboard } from "../../api";
import AdminOnly from "../../components/Auth/AdminOnly";
import MyIcon from "../../components/Icon/MyIcon";
import { colors } from "../../styles";
import { IAdminDashboard } from "../../types";

export default function Main() {

    const { data: dashboardData, isLoading: isDashboardDataLoading, error: dashboardError } = useQuery<IAdminDashboard>({
        queryKey: ["adminDashboard"],
        queryFn: adminGetDashboard
    });

    /* render */

    return (
        <AdminOnly>
            <Stack width={"100%"} padding={10}>

                <SimpleGrid width={"100%"} columns={2} gap={5}>
                    <Card
                        width={"100%"}
                        height={150}
                        border={`0.5px solid ${colors.g4}`}
                        borderRadius={10}
                        shadow={"md"}
                    >
                        <CardBody>
                            <VStack width={"100%"} height={"100%"} justifyContent={"center"} alignItems={"flex-start"}>
                                <HStack justifyContent={"flex-start"} alignItems={"center"} gap={2}>
                                    <Text fontSize={16} fontWeight={500}>PENDING USER</Text>
                                </HStack>
                                <Text fontSize={48} fontWeight={400} color={colors.link}>{dashboardData?.pendingUsersCount}</Text>
                            </VStack>
                        </CardBody>
                    </Card>
                    <Card
                        width={"100%"}
                        height={150}
                        border={`0.5px solid ${colors.g4}`}
                        borderRadius={10}
                        shadow={"md"}
                    >
                        <CardBody>
                            <VStack width={"100%"} height={"100%"} justifyContent={"center"} alignItems={"flex-start"}>
                                <HStack justifyContent={"flex-start"} alignItems={"center"} gap={2}>
                                    <Text fontSize={16} fontWeight={500}>EDITED USER</Text>
                                </HStack>
                                <Text fontSize={48} fontWeight={400} color={colors.covalt}>{dashboardData?.editedUsersCount}</Text>
                            </VStack>
                        </CardBody>
                    </Card>
                    <Card
                        width={"100%"}
                        height={150}
                        border={`0.5px solid ${colors.g4}`}
                        borderRadius={10}
                        shadow={"md"}
                    >
                        <CardBody>
                            <VStack width={"100%"} height={"100%"} justifyContent={"center"} alignItems={"flex-start"}>
                                <HStack justifyContent={"flex-start"} alignItems={"center"} gap={2}>
                                    <MyIcon src={"/svg/messenger-filled.svg"} alt="messenger-filled" width={24} height={24} />
                                    <Text fontSize={16} fontWeight={500}>REPORTED CHATS</Text>
                                </HStack>
                                <Text fontSize={48} fontWeight={400} color={colors.apple}>{dashboardData?.reportedChatsCount}</Text>
                            </VStack>
                        </CardBody>
                    </Card>
                    <Card
                        width={"100%"}
                        height={150}
                        border={`0.5px solid ${colors.g4}`}
                        borderRadius={10}
                        shadow={"md"}
                    >
                        <CardBody>
                            <VStack width={"100%"} height={"100%"} justifyContent={"center"} alignItems={"flex-start"}>
                                <HStack justifyContent={"flex-start"} alignItems={"center"} gap={2}>
                                    <MyIcon src={"/svg/message-circle.svg"} alt="message-circle" width={24} height={24} />
                                    <Text fontSize={16} fontWeight={500}>REPORTED COMMENTS</Text>
                                </HStack>
                                <Text fontSize={48} fontWeight={400} color={colors.apple}>{dashboardData?.reportedCommentsCount}</Text>
                            </VStack>
                        </CardBody>
                    </Card>
                    <Card
                        width={"100%"}
                        height={150}
                        border={`0.5px solid ${colors.g4}`}
                        borderRadius={10}
                        shadow={"md"}
                    >
                        <CardBody>
                            <VStack width={"100%"} height={"100%"} justifyContent={"center"} alignItems={"flex-start"}>
                                <HStack justifyContent={"flex-start"} alignItems={"center"} gap={2}>
                                    <MyIcon src={"/svg/message-circle.svg"} alt="message-circle" width={24} height={24} />
                                    <Text fontSize={16} fontWeight={500}>REPORTED REPLIES</Text>
                                </HStack>
                                <Text fontSize={48} fontWeight={400} color={colors.apple}>{dashboardData?.reportedRepliesCount}</Text>
                            </VStack>
                        </CardBody>
                    </Card>
                </SimpleGrid>

                <Divider marginY={10} />

                <VStack width={"100%"} gap={5}>
                    <Card
                        width={"100%"}
                        height={150}
                        border={`0.5px solid ${colors.g4}`}
                        borderRadius={10}
                        shadow={"md"}
                    >
                        <CardBody>
                            <VStack width={"100%"} height={"100%"} justifyContent={"center"} alignItems={"flex-start"}>
                                <HStack justifyContent={"flex-start"} alignItems={"center"} gap={2}>
                                    <MyIcon src={"/svg/callbook-filled.svg"} alt="user" width={24} height={24} />
                                    <Text fontSize={16} fontWeight={500}>등록된 회원 수</Text>
                                </HStack>
                                <Text fontSize={48} fontWeight={400} color={colors.black}>{dashboardData?.usersCount}</Text>
                            </VStack>
                        </CardBody>
                    </Card>
                    <Card
                        width={"100%"}
                        height={150}
                        border={`0.5px solid ${colors.g4}`}
                        borderRadius={10}
                        shadow={"md"}
                    >
                        <CardBody>
                            <VStack width={"100%"} height={"100%"} justifyContent={"center"} alignItems={"flex-start"}>
                                <HStack justifyContent={"flex-start"} alignItems={"center"} gap={2}>
                                    <MyIcon src={"/svg/pharm-filled.svg"} alt="pharm" width={24} height={24} />
                                    <Text fontSize={16} fontWeight={500}>등록된 약국 수</Text>
                                </HStack>
                                <Text fontSize={48} fontWeight={400} color={colors.black}>{dashboardData?.pharmaciesCount}</Text>
                            </VStack>
                        </CardBody>
                    </Card>
                    <Card
                        width={"100%"}
                        height={150}
                        border={`0.5px solid ${colors.g4}`}
                        borderRadius={10}
                        shadow={"md"}
                    >
                        <CardBody>
                            <VStack width={"100%"} height={"100%"} justifyContent={"center"} alignItems={"flex-start"}>
                                <HStack justifyContent={"flex-start"} alignItems={"center"} gap={2}>
                                    <MyIcon src={"/svg/capsule-filled.svg"} alt="capsule" width={24} height={24} />
                                    <Text fontSize={16} fontWeight={500}>등록된 약품 수</Text>
                                </HStack>
                                <Text fontSize={48} fontWeight={400} color={colors.black}>{dashboardData?.medicinesCount}</Text>
                            </VStack>
                        </CardBody>
                    </Card>
                    <Card
                        width={"100%"}
                        height={150}
                        border={`0.5px solid ${colors.g4}`}
                        borderRadius={10}
                        shadow={"md"}
                    >
                        <CardBody>
                            <VStack width={"100%"} height={"100%"} justifyContent={"center"} alignItems={"flex-start"}>
                                <HStack justifyContent={"flex-start"} alignItems={"center"} gap={2}>
                                    <MyIcon src={"/svg/arrow-right.svg"} alt="keyword" width={24} height={24} />
                                    <Text fontSize={16} fontWeight={500}>등록된 키워드 수</Text>
                                </HStack>
                                <Text fontSize={48} fontWeight={400} color={colors.black}>{dashboardData?.keywordsCount}</Text>
                            </VStack>
                        </CardBody>
                    </Card>
                </VStack>

                <Divider marginY={10} />

                <SimpleGrid width={"100%"} columns={2} gap={5}>
                    <Card
                        width={"100%"}
                        height={150}
                        border={`0.5px solid ${colors.g4}`}
                        borderRadius={10}
                        shadow={"md"}
                    >
                        <CardBody>
                            <VStack width={"100%"} height={"100%"} justifyContent={"center"} alignItems={"flex-start"}>
                                <HStack justifyContent={"flex-start"} alignItems={"center"} gap={2}>
                                    <MyIcon src={"/svg/search.svg"} alt="search" width={24} height={24} />
                                    <Text fontSize={16} fontWeight={500}>오늘 검색 수</Text>
                                </HStack>
                                <Text fontSize={48} fontWeight={400} color={colors.black}>{dashboardData?.todaySearchCount}</Text>
                            </VStack>
                        </CardBody>
                    </Card>
                    <Card
                        width={"100%"}
                        height={150}
                        border={`0.5px solid ${colors.g4}`}
                        borderRadius={10}
                        shadow={"md"}
                    >
                        <CardBody>
                            <VStack width={"100%"} height={"100%"} justifyContent={"center"} alignItems={"flex-start"}>
                                <HStack justifyContent={"flex-start"} alignItems={"center"} gap={2}>
                                    <MyIcon src={"/svg/callbook-line-g1.svg"} alt="callbook-line-g1" width={24} height={24} />
                                    <Text fontSize={16} fontWeight={500}>오늘 검색 사용자 수</Text>
                                </HStack>
                                <Text fontSize={48} fontWeight={400} color={colors.black}>{dashboardData?.todaySearchUsersCount}</Text>
                            </VStack>
                        </CardBody>
                    </Card>
                    <Card
                        width={"100%"}
                        height={150}
                        border={`0.5px solid ${colors.g4}`}
                        borderRadius={10}
                        shadow={"md"}
                    >
                        <CardBody>
                            <VStack width={"100%"} height={"100%"} justifyContent={"center"} alignItems={"flex-start"}>
                                <HStack justifyContent={"flex-start"} alignItems={"center"} gap={2}>
                                    <MyIcon src={"/svg/search-link.svg"} alt="search-link" width={24} height={24} />
                                    <Text fontSize={16} fontWeight={500}>누적 검색 수</Text>
                                </HStack>
                                <Text fontSize={48} fontWeight={400} color={colors.black}>{dashboardData?.totalSearchCount}</Text>
                            </VStack>
                        </CardBody>
                    </Card>
                </SimpleGrid>
            </Stack>
        </AdminOnly>
    )
}